import { WhatsAppIcon } from "./WhatsAppIcon";
import { CONTACT } from "../../data/site";

export const WhatsAppFab = () => (
  <a
    href={CONTACT.whatsapp}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Chat on WhatsApp"
    data-testid="floating-whatsapp-button"
    className="fab fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg transition-transform duration-300 hover:scale-110"
  >
    <WhatsAppIcon className="h-7 w-7" />
  </a>
);
